module.exports = __webpack_public_path__ + "img/button_normal.44da2432.png";